// Phase RV-UI / GAP 2 — Stake decision screen state machine.
//
// PRD v2.2 §6 states the post-win decision screen MUST only render when
// the current week has actually resolved as a win. Until now the screen
// rendered unconditionally — which is why "Full compound" and "Floor"
// could appear equal (week_number=1, current_value=opening, so both
// branches produced the seed value).
//
// Mapping STRIKZA phantom statuses → brief screen states:
//   no_chain       → no rollover_chains row for caller
//   bust_recovery  → current cycle status = 'phantom_busted'
//   stake_decision → current cycle status = 'phantom_won'
//   in_progress    → 'phantom_recommended' / 'phantom_confirmed' / 'recommended'

export type RolloverScreenState =
  | "no_chain"
  | "in_progress"
  | "stake_decision"
  | "bust_recovery";

export interface ScreenStateInputs {
  readonly hasChain: boolean;
  readonly cycleStatus: string | null | undefined;
}

const WON_STATUSES: ReadonlySet<string> = new Set(["phantom_won"]);
const LOST_STATUSES: ReadonlySet<string> = new Set(["phantom_busted"]);

export function resolveScreenState({
  hasChain,
  cycleStatus,
}: ScreenStateInputs): RolloverScreenState {
  if (!hasChain) return "no_chain";
  if (cycleStatus && LOST_STATUSES.has(cycleStatus)) return "bust_recovery";
  if (cycleStatus && WON_STATUSES.has(cycleStatus)) return "stake_decision";
  return "in_progress";
}
